
<span *ngIf="buttonType === 'remind'" (click)="remindSignatory()" class="mr-6 btn btn-md text-left btn-outline-success btn-style-right-1">
  <a id="remind-signatory" class="fs-16 align-middle">
    Remind Signatories
  </a>
</span>

<span *ngIf="buttonType === 'resend'"  (click)="resendForSign()"
  class="w-25 mr-5 btn btn-md text-left btn-style-right-1 btn-success for-icon-right for-right-arrow">
  <a id="resend-docs-for-sign" class="fs-16 align-middle">
    Modify Signatories
  </a>
</span>